import { generateIdempotencyKey } from '@/lib/utils'
import { useState } from 'react'

export function useRotatingIdempotencyKey(
  createKey: () => string = generateIdempotencyKey
): [string, () => void] {
  const [idempotencyKey, setIdempotencyKey] = useState(() => createKey())

  return [idempotencyKey, () => setIdempotencyKey(createKey())]
}
